import React from 'react';
import PropTypes from 'prop-types';
import {Button} from '../../../Button';

export function ModalViewControls(props) {

  const views  = {
    TOP_VIEW: "Top view",
    SIDE_VIEW: "Side view"
  };
  const onClick = (event) => {
    event.stopPropagation();
    props.onClick();
  };

  //${props.className}

  return (
    <div className={`viewControls`}>
      {props.views.map(view => {
        return(
          <Button
            class={(props.currentView == Object.keys(view)[0])?"active":"primary"}
            disabled={(
              props.currentView === "TOP_VIEW" &&
              props.selectedLane === null &&
              Object.keys(view)[0] === "SIDE_VIEW"
            )}
            onClick={()=>props.setCurrentView(Object.keys(view)[0])}
          >
            {views[view[Object.keys(view)[0]]]}
          </Button>
        )
      })}
    </div>
  );
}

ModalViewControls.propTypes = {
  /**
   * ClassName to set on ModalViewControls
   */
  className: PropTypes.string,
  /**
   * List of views
   */
  views: PropTypes.string,
  /**
   * Function to set the current view
   */
  setCurrentView: PropTypes.func,
  /**
   * The current view string
   */
  currentView: PropTypes.string,
};

ModalViewControls.defaultProps = {
    disabled: false
};
